// extracted by mini-css-extract-plugin
export default {"container":"for_FJoKU","status":"for_sta_2OzwH","icon":"for_ico_1GYcD","spin":"for_spi_2QZdh","message":"for_mes_KMVLu","iconRight":"for_ico_2JnMl"};